import { applyMiddleware, compose, createStore } from 'redux';
import persistState from 'redux-localstorage';
import { sendLog, invalidateLocalStorage } from '@siteground/styleguide';

import createRootReducer from './reducers';
import createSagaMiddleware from 'redux-saga';
import sagas from './sagas';
import { routerMiddleware, createReduxHistory } from './history';

import { getClientJWTPayload } from './selectors/chat-session';

export let store;
export let history;

// USE THIS ONLY FOR DEBUGGING ON LOCAL ENV
// @ts-ignore
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? // @ts-ignore
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension's options like name, actionsBlacklist, actionsCreators, serialize...
        name: 'CLIENT_FRONTEND_STORE'
      })
    : compose;

const onSagaError = (error, errorInfo) => {
  const parsedErrorInfo = {
    componentStack: errorInfo ? JSON.stringify(errorInfo.sagaStack) : '-'
  };

  const clientJwtPayload = store && typeof store.getState === 'function' ? getClientJWTPayload(store.getState()) : {};

  sendLog({
    error: `Chat-Saga-Error --->>> ${error}`,
    errorInfo: parsedErrorInfo,
    // uid: 'https://0.0.0.0:2001_log', // debug url
    data: JSON.stringify({
      agent: window.navigator.userAgent,
      ...clientJwtPayload
    })
  });
};

export default function configureStore(preloadedState) {
  const sagaMiddleware = createSagaMiddleware({ onError: onSagaError });

  invalidateLocalStorage(
    {
      chat_session: 9
    },
    'clients_fe_invalidation'
  );

  store = createStore(
    createRootReducer, // root reducer with router state
    preloadedState,
    compose(applyMiddleware(sagaMiddleware, routerMiddleware), persistState('chatSession', { key: 'chat_session' }))
  );

  sagaMiddleware.run(sagas);

  history = createReduxHistory(store);

  return store;
}
